<template>
  <div>
    <div class="row">
      <div class="input-field col s12 m12 l6 xl6">
        <input
          id="nome"
          name="nome"
          type="text"
          class="validate"
          v-model='uni.nome'
          @input="verifyNome"
          maxlength="100"
          v-bind:class="{ 'red-text': !nomeLength, 'black-text': nomeLength }"
          required
          >
        <label for="nome">Nome</label>
      </div>
      <div class="input-field col s12 m12 l6 xl6">
        <select name="centro" v-model='uni.centro_id' required class="browser-default select_sec">
          <option value='' disabled selected>Centro</option>
          <option
          v-for="centro in this.cen"
          :value="centro.id"
          :selected="centro.id === uni.centro_id"
           >{{centro.nome}}</option>
        </select>
      </div>
	  </div>
	  <div class="row">
      <div class="input-field col s6 m6 l3 xl3">
        <button type="submit" class="btn">
          <i class="material-icons left">save</i>
          Salvar</button>
      </div>
      <div class="input-field col s6 m6 l3 xl3">
        <button v-if="!uni.id" type="reset" class="btn indigo" @click="clear">
          <i class="material-icons right">clear</i>
          Limpar</button>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      name: "VueUnidadeForm",
      props: [
        'unidade',
        'centros'
      ],
      data () {
        return {
          uni: JSON.parse(this.unidade),
          info: '',
          nomeLength: false,
          nomeGuard: '',
          cen: JSON.parse(this.centros),
        }
      },
      computed: {
       centroId() {
          return this.uni.centro_id;
       }
      },
      methods: {
        verifyNome () {
          this.verifyNomeLength()
        },
        clear (ev, nomeInput = '') {
          this.uni = {
            nome: nomeInput,
            centro_id: -1,
          }
        },
        verifyNomeLength() {
          if (this.uni.nome.length <= 100)
            this.nomeLength = true
          else
            this.nomeLength = false
        },
      },
      ready () {
      }
    }

</script>
